import { axiosRequest, type AxiosResult } from "@/lib/axios";
import type { WallOfLoveTemplate, WallOfLoveTemplateListItem } from "../types";

const API_BASE_URL = import.meta.env.VITE_SERVICE_CORE_URL;

export const wallOfLoveTemplateApi = {
	index: (): Promise<AxiosResult<WallOfLoveTemplateListItem[]>> => {
		return axiosRequest({ url: `${API_BASE_URL}/wall-templates`, method: "GET" });
	},
	show: (template: string, version: number): Promise<AxiosResult<WallOfLoveTemplate>> => {
		return axiosRequest({ url: `${API_BASE_URL}/wall-templates/${template}/${version}`, method: "GET" });
	},
};
